import { rolesFromRoleSpecialties, specialtyToRolesMapFromRoleSpecialties } from '../helpers/roleSpecialties';
import { CandidateProfileFormData, UpdateCandidateProfileRequest } from '../types';

export default function formDataToUpdateProfile(
    data: CandidateProfileFormData,
    isRoleSpecialtyEnabled: boolean
): UpdateCandidateProfileRequest {
    const base = {
        firstName: data.firstName,
        lastName: data.lastName,
        mobilePhone: data.mobilePhone,
        location: data.location,
        skillIds: data.skills.map(skill => skill.id),
        communicationPreferences: data.communicationPreferences
    };

    if (!isRoleSpecialtyEnabled) {
        // Legacy role-only path: send role ids from the plain roles field.
        return {
            ...base,
            roleIds: data.roles.map(role => role.id)
        };
    }

    // Flat roles list is updated independently of the speciality map; send both.
    return {
        ...base,
        roleIds: rolesFromRoleSpecialties(data.roleSpecialties).map(role => role.id),
        specialtyToRolesMap: specialtyToRolesMapFromRoleSpecialties(data.roleSpecialties)
    };
}
